import { IncomingMessage } from "./incoming-message.js";
/**
 * Incoming request message.
 * @public
 */
export class IncomingRequestMessage extends IncomingMessage {
    constructor() {
        super();
    }
}
